export const PEOPLE_TABS = ["employees", "structure", "availability"] as const;
export type PeopleTab = (typeof PEOPLE_TABS)[number];

export function isPeopleTab(value: unknown): value is PeopleTab {
  return typeof value === "string" && PEOPLE_TABS.some((tab) => tab === value);
}
